// removed by extract-text-webpack-plugin
module.exports = {"text800":"nf64RLIDTkfPSV6bW3Lh4","text700":"J8TTkYjIoHj2HqCWwD7Jc","text600":"_37nB4slm18gcbflsB9TDHd","text500":"_1IW-unsXfdtmvwL7WhiXSt","text400":"kttFgwL10QZX8Zyq9sChZ","text300":"_342N7wwmqZO75-aHcvswaM","text200":"_53-KCt56jbkaK9aLOer17","textParagraph":"_1SPY32vuVLX6UdQE4xIlza","crimp":"_18nPCOXntXc4sRPZqDb0UH","trim":"_2Pf-MhOINdC5kU_UF9LpQI","flexCenter":"_3HnzwcnKCog0-EqVXThsuM","hideTextOverflow":"PDuOiO_R_58FsJ1AT50Iq","marginPageMainContent":"_3jlwVsKwMzXKUDQNu6kBM_","actionButton":"_1bIVWadi2LeaBUPWkuhZXs"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/forms/ButtonSubmit.scss
// module id = 966
// module chunks = 0